import axios from 'axios';
import API_BASE_URL from '../config/appConfig';
import {
  guardarMensajeSesion,
  limpiarSesionAuth,
  obtenerTokenSesion
} from '../utils/sesion';

const api = axios.create({
  baseURL: API_BASE_URL
});

let redirigiendoPorSesion = false;

function limpiarSesionExpirada(mensaje) {
  limpiarSesionAuth();
  guardarMensajeSesion(mensaje);
}

api.interceptors.request.use((config) => {
  const token = obtenerTokenSesion();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = String(error.config?.url || '');
    const esLogin = url.includes('/auth/login');

    if (status === 401 && !esLogin) {
      const mensaje =
        error.response?.data?.mensaje ||
        'Tu sesión expiró. Inicia sesión nuevamente.';

      limpiarSesionExpirada(mensaje);

      if (!redirigiendoPorSesion) {
        redirigiendoPorSesion = true;

        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
